
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { DimssaButton, ButtonState } from "@/components/dimssa-button.vue"
import * as Models from "@gigalot/data-models"
import store, { mapFields, mapMultiRowFields } from "@/store"
import lodash from "lodash"
import * as helpers from "@/helpers"
import { updateDestinationAbattoir } from "@/helpers/graphql"

@Component({
  components: {
    DimssaButton,
  },
  computed: {
    ...mapFields(["destinationAbattoir.name", "destinationAbattoir.gcp", "destinationAbattoir.vat"]),
  },
})
export default class Abattoir extends Vue {
  gln: string = ""
  glnVerified: boolean = false

  gpsLat: string = ""
  gpsLon: string = ""

  @Watch("gln")
  onGlnChanged(gln: any) {
    console.log("onGlnChanged: " + gln)
    this.glnVerifyButtonState = "ready"
    this.glnVerified = false
  }

  glnVerifyButtonState: ButtonState = "ready"
  async verifyGln() {
    this.glnVerifyButtonState = "busy"
    try {
      let json = await this.$store.dispatch(
        "graphQl",
        {
          gql: `query rmisProductionUnitsGetName($gln: String!) {
            rmisProductionUnitsGetName(gln: $gln)
          }`,
          variables: {
            gln: this.gln,
          },
        },
        { root: true }
      )

      console.log(JSON.stringify(json))
      console.log(json.data.rmisProductionUnitsGetName)

      if (json?.data?.rmisProductionUnitsGetName) {
        this.$store.commit("popup/displayOk", json.data.rmisProductionUnitsGetName)
      }

      this.glnVerified = true

      this.glnVerifyButtonState = "success"
    } catch (err) {
      this.glnVerifyButtonState = "error"
      console.error(err)
    }
  }

  created() {
    let destinationAbattoir: Models.Abattoir = this.$store.getters["getField"]("destinationAbattoir")
    if (destinationAbattoir.gln) {
      this.gln = destinationAbattoir.gln
      this.glnVerified = true
    }
    if (destinationAbattoir.gps) {
      const gps = destinationAbattoir.gps
      if (gps.lat) {
        this.gpsLat = `${gps.lat}`
      }
      if (gps.lon) {
        this.gpsLon = `${gps.lon}`
      }
    }
  }

  saveButtonState: ButtonState = "ready"
  async save() {
    try {
      this.saveButtonState = "busy"

      if (!this.glnVerified && this.gln.length > 0) {
        this.$store.commit("popup/displayOk", `Can not save, GLN unverified.`)
        this.saveButtonState = "error"
        return
      }

      let destinationAbattoir = this.$store.getters["getField"]("destinationAbattoir")

      if (this.gln) destinationAbattoir.gln = this.gln

      if (this.gpsLat !== "") destinationAbattoir.gps.lat = parseFloat(this.gpsLat)
      if (this.gpsLon !== "") destinationAbattoir.gps.lon = parseFloat(this.gpsLon)

      await updateDestinationAbattoir(destinationAbattoir)
      this.saveButtonState = "success"
    } catch (err) {
      console.error(`Error saving Destination Abattoir`)
      console.error(err)
      this.saveButtonState = "error"
    }
  }
}
